import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getValue } from '_utils';
import { licensePoolPropType } from '_utils/licensePools';

import { Button, Form } from 'semantic-ui-react';
import BaseNumberField from '_forms/baseNumber'
import BaseInputField from './baseInput';

const getPoolCountState = licensePool => ({
  ac_count: licensePool.ac_count,
  key_count: licensePool.key_count,
  ilok_count: licensePool.ilok_count,
  keyserver_count: licensePool.keyserver_count,
  ilok_account_name: licensePool.ilok_account_name,
  description: licensePool.description || ""
});

const ModifyLicensePoolCountsForm = ({ licensePool, onSubmit }) => {

  const [settings, setSettings] = useState(getPoolCountState(licensePool));

  const isDirty = Object.entries(settings).reduce((result, [key, value]) => result || licensePool[key] !== value, false);

  const onCancel = () => setSettings(getPoolCountState(licensePool));
  const onSubmitForm = () => isDirty && onSubmit(settings);

  const onChange = (e, data) => {
    setSettings(Object.assign({}, settings, { [data.name]: getValue(data) }));
  };

  return (
    <Form size='tiny' onSubmit={ onSubmitForm } >
      <Form.Group>
        <BaseNumberField
          width={ 8 }
          min={ 0 }
          name='ac_count'
          labelTxt='Activation Code Pool'
          popupTxt='How many seats are reserved for Max 8 AC authorizations?'
          value={ settings.ac_count }
          onChange={ onChange }
        />
        <BaseNumberField
          width={ 8 }
          min={ 0 }
          labelTxt='Key Pool'
          popupTxt='How many seats are reserved for Max 8 key authorizations?'
          name='key_count'
          value={ settings.key_count }
          onChange={ onChange }
        />
      </Form.Group>
      <Form.Group>
        <BaseNumberField
          width={ 8 }
          min={ 0 }
          name='ilok_count'
          labelTxt='iLok Pool'
          popupTxt='How many seats are reserved for Max 8 ilok authorizations?'
          value={ settings.ilok_count }
          onChange={ onChange }
        />
        <BaseNumberField
          width={ 8 }
          min={ 0 }
          labelTxt='Keyserver Pool'
          popupTxt='How many seats are reserved for Max 8 keyserver authorizations?'
          name='keyserver_count'
          value={ settings.keyserver_count }
          onChange={ onChange }
        />
      </Form.Group>
      <Form.Group>
        <BaseInputField
          width={ 8 }
          name='ilok_account_name'
          labelTxt='iLok Account Name'
          popupTxt='iLok Account Name for License Pool, if applicable.'
          value={ settings.ilok_account_name }
          onChange={ onChange }
        />
      </Form.Group>
      <Form.Group>
        <BaseInputField
          width={ 16 }
          name='description'
          labelTxt='Description'
          popupTxt='Optional description to identify this license pool. Note that the info here will be visible to 3rd party admins as well.'
          value={ settings.description }
          onChange={ onChange }
        />
      </Form.Group>
      <Button.Group>
        <Button disabled={!isDirty} onClick={ onCancel }>Cancel</Button>
        <Button.Or />
        <Button positive={isDirty} disabled={!isDirty} type="submit">Save</Button>
      </Button.Group>
    </Form>
  )
};

ModifyLicensePoolCountsForm.propTypes = {
  licensePool: licensePoolPropType.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ModifyLicensePoolCountsForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/institutionLicensePoolFormCounts.js